module.exports = __webpack_public_path__ + "static/media/bell.47fc8d1b.svg";